import React, { useEffect, useMemo, useRef, useState } from "react";
import Moment from "moment";
import PropTypes from "prop-types";
import VmoButton from "../../Elements/VmoButton/VmoButton";
import VmoDropdown from "../../Modules/Dropdown/VmoDropdown";
import VmoDropdownItem from "../../Modules/Dropdown/VmoDropdownItem";
import VmoDropdownMenu from "../../Modules/Dropdown/VmoDropdownMenu";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const VmoDateRangePicker = (props) => {
  const {
    run = () => null,
    dependencies = [],
    onlyDateRange = false,
    button2Ref = null,
    left = false,
    localItem = "",
    numberOfDays = 7,
    onlyComponent = false,
  } = props;

  const dateRef = useRef();
  const [date, setDate] = useState(false);
  const currData = JSON.parse(window.localStorage.getItem(localItem) || "{}");
  const [startDate, setStartDate] = useState(
    () =>
      currData?.persistDateRangeStartDate ||
      Moment().subtract(numberOfDays - 1, "days").startOf("day")
  );

  const [endDate, setEndDate] = useState(
    () => currData?.persistDateRangeEndDate || Moment().endOf("day")
  );
  const [selection, setSelection] = useState([
    {
      startDate: new Date(startDate),
      endDate: new Date(endDate),
      key: "selection",
    },
  ]);

  const data = {
    from: Moment(selection[0].startDate).format("YYYY-MM-DD 00:00:00"),
    to: Moment(selection[0].endDate).format("YYYY-MM-DD 23:59:59"),
  };

  const depen = useMemo(
    () => [startDate, endDate, onlyDateRange, ...dependencies],
    [startDate, endDate, onlyDateRange, ...dependencies]
  );

  useEffect(() => {
    function handleClickOutside(e) {
      if (dateRef.current && !dateRef.current.contains(e.target)) {
        setDate(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dateRef]);

  useEffect(() => {
    if (onlyDateRange) return;
    run(data);
    window.localStorage.setItem(
      localItem,
      JSON.stringify({
        ...currData,
        persistDateRangeStartDate: startDate,
        persistDateRangeEndDate: endDate,
      })
    );
  }, depen);

  const onApply = () => {
    setStartDate(selection[0].startDate);
    setEndDate(selection[0].endDate);
  };

  const onApplyDateRange = () => {
    run(data);
    window.localStorage.setItem(
      localItem,
      JSON.stringify({
        ...currData,
        persistDateRangeStartDate: selection[0].startDate,
        persistDateRangeEndDate: selection[0].endDate,
      })
    );
  };
  if (onlyComponent) {
    return <DateRangePicker {...props} />
  }
  if (onlyDateRange) {
    return (
      <React.Fragment>
        <DateRangePicker
          className="customDateRange"
          moveRangeOnFirstSelection={false}
          ranges={selection}
          onChange={({ selection: newSelection }) => {
            setSelection([newSelection]);
          }}
        />
        <button
          ref={button2Ref}
          type="button"
          hidden
          onClick={onApplyDateRange}
        >
          Apply
        </button>
      </React.Fragment>
    );
  }
  return (
    <VmoDropdown
      basic
      button
      className="data-pick"
      text={
        Moment(currData?.persistDateRangeStartDate).format("DDMMYYYY") !==
        Moment(currData?.persistDateRangeEndDate).format("DDMMYYYY")
          ? `${Moment(currData?.persistDateRangeStartDate).format(
              "DD MMM, YYYY"
            )} to ${Moment(currData?.persistDateRangeEndDate).format(
              "DD MMM, YYYY"
            )}`
          : Moment(currData?.persistDateRangeEndDate).format("DD MMM, YYYY")
      }
    >
      <VmoDropdownMenu className={left ? "left" : ""}>
        <VmoDropdownItem ref={dateRef} onClick={(e) => e.stopPropagation()}>
          <DateRangePicker
            moveRangeOnFirstSelection={false}
            ranges={selection}
            onChange={({ selection: newSelection }) => {
              setSelection([newSelection]);
            }}
          />
        </VmoDropdownItem>

        <div className="action">
          <VmoButton basic onClick={() => setDate(false)}>
            Close
          </VmoButton>
          <VmoButton primary onClick={onApply}>
            Apply
          </VmoButton>
        </div>
      </VmoDropdownMenu>
    </VmoDropdown>
  );
};
export default VmoDateRangePicker;

VmoDateRangePicker.prototype = {
  run: PropTypes.func,
  dependencies: PropTypes.array,
  onlyDateRange: PropTypes.bool,
  button2Ref: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
  left: PropTypes.bool,
  localItem: PropTypes.string.isRequired,
  numberOfDays: PropTypes.number,
  onlyComponent: PropTypes.bool
};

VmoDateRangePicker.defaultProps = {
  run: () => null,
  dependencies: [],
  onlyDateRange: false,
  button2Ref: null,
  left: false,
  localItem: "",
  numberOfDays: 7,
  onlyComponent: false
};
